// extracted by mini-css-extract-plugin
export default {"root":"IconDishwasherGen_root__ys-AW"};